// removed by extract-text-webpack-plugin
module.exports = {"contact":"src-components----ContactInfo-module---contact---1VdXG","avatar":"src-components----ContactInfo-module---avatar---xxmdo","secondary":"src-components----ContactInfo-module---secondary---2PPsR","contacts":"src-components----ContactInfo-module---contacts---30TvL","address":"src-components----ContactInfo-module---address---1i0DX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactInfo.module.css
// module id = 723
// module chunks = 226573449209678